import React from 'react';

import { Done } from '@mui/icons-material';
import { Alert, Button, Typography } from '@mui/material';

import { formatDateLongMonthWithMeridiemNoSeconds } from '~/services/TimeService';

import UserName from '../Common/UserName';
import usePromoApproval from '../Promo/hooks/usePromoApproval';
import usePromoAdminPermission from '../Promo/hooks/usePromoPermission';

type PromoApproveButtonProps = {
  codeName: string;
  brand: string;
  isApprovedBy: string;
  isApprovedAt: string;
};

function PromoApproveButton({ codeName, brand, isApprovedBy, isApprovedAt }: PromoApproveButtonProps) {
  const { isLoading, error, data, requestApproval, requestUnapproval } = usePromoApproval();
  const isPromoAdmin = usePromoAdminPermission();
  const handleApprove = () => {
    requestApproval({ codeName, brand });
  };

  const handleUnapprove = () => {
    requestUnapproval({ codeName, brand });
  };

  if (!isPromoAdmin) {
    return null;
  }

  if (isLoading) {
    return (
      <Button variant="contained" size="small">
        Loading...
      </Button>
    );
  }

  if (error) {
    return <Alert severity="error">Error</Alert>;
  }

  if (isApprovedBy) {
    return (
      <>
        <Done />
        <Typography variant="subtitle2" sx={{ mb: 1 }}>
          <UserName asLink userId={isApprovedBy} />
          (approved {formatDateLongMonthWithMeridiemNoSeconds(isApprovedAt)} )
        </Typography>
      </>
    );
  } else {
    return (
      <Button
        variant="contained"
        color="secondary"
        title="(currently SOFT-LAUNCH - soon to be enabled - contact growth team for more information about the approval options) - Before this promo can be used, it must be approved by a promo admin"
        onClick={handleApprove}
        size="small"
      >
        Approve
      </Button>
    );
  }
}

export default PromoApproveButton;
